module.exports = __webpack_public_path__ + "static/media/background-two.5d992ced.png";